import React, { useState } from 'react';
import { Tabs } from 'antd';

import SearchLookupForm from 'modules/lookup_table/searchLookupForm';
import SearchPaymentTermsTable from "modules/lookup_table/search_lookup_table/paymentTermsTable";
import SearchVatInputTable from 'modules/lookup_table/search_lookup_table/vatInputTable';
import SearchStatusTable from 'modules/lookup_table/search_lookup_table/statusTable';
import SearchUnitsTable from 'modules/lookup_table/search_lookup_table/unitsTable';
import SearchCurrencyTable from 'modules/lookup_table/search_lookup_table/currencyTable';
import SearchBankTable from 'modules/lookup_table/search_lookup_table/bankTable';
import SearchPaymentMethodTable from 'modules/lookup_table/search_lookup_table/paymentMethodTable';
import SearchEwtTable from 'modules/lookup_table/search_lookup_table/ewtTable';
import SortTestPaymentTermsTable from 'modules/lookup_table/search_lookup_table/sortTestpaymentTerms';

const { TabPane } = Tabs;

function TabPanes() {
    const [data, setData] = useState([]);

    const onChange = (key) => {
      console.log(key);
      setData([])
    };

    function search(values) {
        setData(values);
    };

    return( 
        <div>
            <Tabs defaultActiveKey='1' onChange={onChange} type='card' >
                <TabPane
                    tab='PAYMENT TERMS'
                    key={1}
                >
                    <SearchLookupForm placeholder='PAYMENT TERM NAME' addButton='PAYMENT TERM' onFinish={ search } />
                    <SearchPaymentTermsTable data={data} lookupValue='PAYMENT TERM' />
                </TabPane>
                <TabPane
                    tab='VAT INPUT'
                    key={2}
                >
                    <SearchLookupForm placeholder='VAT INPUT NAME' addButton='VAT INPUT' onFinish={ search } />
                    <SearchVatInputTable data={data} lookupValue='VAT INPUT' />
                </TabPane>
                <TabPane
                    tab='STATUS'
                    key={3}
                >
                    <SearchLookupForm placeholder='STATUS' addButton='STATUS' onFinish={ search } />
                    <SearchStatusTable data={data} lookupValue='STATUS' />
                </TabPane>
                <TabPane
                    tab='UNITS'
                    key={4}
                >
                    <SearchLookupForm placeholder='UNIT CODE' addButton='UNIT' onFinish={ search } />
                    <SearchUnitsTable data={data} lookupValue='UNIT' />
                </TabPane>
                <TabPane
                    tab='CURRENCY'
                    key={5}
                >
                    <SearchLookupForm placeholder='CURRENCY CODE' addButton='CURRENCY' onFinish={ search } />
                    <SearchCurrencyTable data={data} lookupValue='CURRENCY' />
                </TabPane>
                <TabPane
                    tab='BANK'
                    key={6}
                >
                    <SearchLookupForm placeholder='BANK NAME' addButton='BANK' onFinish={ search } />
                    <SearchBankTable data={data} lookupValue='BANK' />
                </TabPane>
                <TabPane
                    tab='PAYMENT METHOD'
                    key={7}
                >
                    <SearchLookupForm placeholder='PAYMENT METHOD NAME' addButton='PAYMENT METHOD' onFinish={ search } />
                    <SearchPaymentMethodTable data={data} lookupValue='PAYMENT METHOD' />
                </TabPane>
                <TabPane
                    tab='EWT'
                    key={8}
                >
                    <SearchLookupForm placeholder='EWT%' addButton='EWT' onFinish={ search } />
                    <SearchEwtTable data={data} lookupValue='EWT' />
                </TabPane>
                <TabPane
                    tab='TEST'
                    key={9}
                >
                    <SearchLookupForm placeholder='testing' addButton='PAYMENT TERM' onFinish={ search } />
                    <SortTestPaymentTermsTable 
                    // data={data} lookupValue='PAYMENT TERM' 
                    />
                </TabPane>
            </Tabs>
        </div>
    )
};

export default TabPanes;